import { defineStore } from 'pinia';
import { ref } from 'vue';
import { jwtDecode } from 'jwt-decode';
import { useToast } from 'primevue/usetoast';
import { useI18n } from 'vue-i18n';
import { authFetch, changeDataFetch } from '@services/authService';

export const useAuthStore = defineStore('authStore', () => {
    const isAuthenticated = ref(false);
    const user = ref(null);
    const userToken = ref(null);
    const toast = useToast();
    // const { t } = useI18n({ useScope: 'global' });

    const clearData = () => {
        isAuthenticated.value = false;
        user.value = null;
        localStorage.removeItem('userToken');
        localStorage.removeItem('user');
    };

    const login = async (username, password) => {
        try {
            const { access_token, image, full_name } = await authFetch({
                username,
                password,
            });
            setAuthData(access_token, image, full_name);
        } catch ({ response }) {
            if (response.statusText === 'Unauthorized') {
                clearData();
            } else if (response.data.response.message === 'invalid.username_or_password') {
                toast.add({ severity: 'error', summary: 'Invalid username or password', life: 3000 });
            }
        }
    };

    const setAuthData = (token, image, full_name) => {
        try {
            const decoded = jwtDecode(token);
            isAuthenticated.value = token ? true : false;
            userToken.value = token;
            
            // Always use decoded token data as primary source
            user.value = { ...decoded, image, full_name };
            
            localStorage.setItem('user', JSON.stringify(user.value));
            localStorage.setItem('userToken', token);
        } catch (error) {
            console.error('Error in setAuthData:', error);
            clearData();
        }
    };
    const changeLocale = (locale) => {
        try {
            user.value = { ...user.value, locale };
            localStorage.setItem('user', JSON.stringify(user.value));
            console.log('Locale changed to:', locale);
        } catch (error) {
            console.error('Error changing locale:', error);
        }
    };
    const changeUserData = async (formData) => {
        const { image, full_name } = formData;
        try {
            const { status } = await changeDataFetch(formData);
            if (status == 200) {
                user.value = { ...user.value, image, full_name };
                
                try {
                    localStorage.setItem('user', JSON.stringify(user.value));
                } catch (storageError) {
                    console.error('Error saving user data to localStorage:', storageError);
                }

                toast.add({ severity: 'success', summary: 'Changes saved successfully', life: 3000 });
            }
        } catch (error) {
            console.error('Error updating user data:', error);
            const errorMessage = error.response?.data?.message || 'Error updating profile';
            toast.add({ severity: 'error', summary: errorMessage, life: 3000 });
        }
    };

    const logout = async () => {
        try {
            // const { data } = await axios.get('https://proctoring-api.univora.uz/services/platon-core/logout', {
            //     headers: {
            //         Authorization: 'Bearer ' + userToken.value,
            //     },
            // });
            clearData();
        } catch (e) {
            console.log(e);
        }
    };

    return {
        isAuthenticated,
        user,
        userToken,
        logout,
        login,
        setAuthData,
        changeUserData,
        changeLocale,
    };
});
